import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPdfRightArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1024 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M426.667 256l-60.16 60.16 195.413 195.84-195.413 195.84 60.16 60.16 256-256z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgPdfRightArrow);
export default ForwardRef;
